import React, { useState, useEffect } from 'react';
import BASE from '../api';
import './MealDrinkPage.css';

export default function MealDrinkPage({ onConfirm, onBack }) {
  const [categories, setCategories] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedFlavor, setSelectedFlavor] = useState(null);
  const [selectedTemp, setSelectedTemp] = useState('冰');

  useEffect(() => {
    fetch(`${BASE}/api/menu`)
      .then(r => r.json())
      .then(data => setCategories(data.filter(c => c.kitchen === 'B')));
  }, []);

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    setSelectedFlavor(null);
    setSelectedTemp('冰');
  };

  const flavors = selectedItem?.combo_options ? selectedItem.combo_options.split('|') : [];
  const needsFlavor = flavors.length > 0;
  const needsTemp = selectedItem?.temperature === 'both';

  const handleConfirm = () => {
    if (!selectedItem) return;
    if (needsFlavor && !selectedFlavor) return;

    const fixedTemp = selectedItem.temperature === 'ice' ? '冰'
      : selectedItem.temperature === 'hot' ? '熱' : null;
    const tempLabel = needsTemp ? selectedTemp : fixedTemp;

    let displayName = selectedItem.name;
    if (needsFlavor) displayName += `(${selectedFlavor})`;
    if (tempLabel) displayName += `(${tempLabel})`;

    onConfirm({ displayName, extraPrice: selectedItem.price - 10 });
  };

  const canConfirm = selectedItem !== null && (!needsFlavor || selectedFlavor !== null);

  return (
    <div className="meal-drink-page">
      <div className="meal-drink-header">
        <button className="meal-drink-back" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          返回
        </button>
        <span className="meal-drink-title">選擇飲品</span>
        <span className="meal-drink-subtitle">套餐折抵 10 元</span>
      </div>

      <div className="meal-drink-body">
        {categories.map(cat => (
          <div key={cat.id} className="meal-drink-cat-section">
            <div className="meal-drink-cat-name">{cat.name}</div>
            {cat.items.filter(item => item.name !== '紅茶').map(item => {
              const isSelected = selectedItem?.id === item.id;
              const netExtra = item.price - 10;
              return (
                <div
                  key={item.id}
                  className={`meal-drink-item${isSelected ? ' selected' : ''}`}
                  onClick={() => handleSelectItem(item)}
                >
                  <span className="meal-drink-item-name">{item.name}</span>
                  <span className="meal-drink-item-extra">+{netExtra}元</span>
                </div>
              );
            })}
          </div>
        ))}

        {needsFlavor && (
          <div className="meal-drink-option-section">
            <div className="meal-drink-option-label">選擇口味</div>
            <div className="meal-drink-option-row">
              {flavors.map(flavor => (
                <button
                  key={flavor}
                  className={`meal-drink-option-btn${selectedFlavor === flavor ? ' selected' : ''}`}
                  onClick={() => setSelectedFlavor(flavor)}
                >
                  {flavor}
                </button>
              ))}
            </div>
          </div>
        )}

        {needsTemp && (
          <div className="meal-drink-temp-section">
            <div className="meal-drink-temp-label">溫度</div>
            <div className="meal-drink-temp-row">
              <button
                className={`meal-drink-temp-btn temp-ice${selectedTemp === '冰' ? ' selected' : ''}`}
                onClick={() => setSelectedTemp('冰')}
              >冰</button>
              <button
                className={`meal-drink-temp-btn temp-hot${selectedTemp === '熱' ? ' selected' : ''}`}
                onClick={() => setSelectedTemp('熱')}
              >熱</button>
            </div>
          </div>
        )}
      </div>

      <div className="meal-drink-footer">
        <button
          className={`meal-drink-confirm-btn${canConfirm ? '' : ' disabled'}`}
          onClick={handleConfirm}
          disabled={!canConfirm}
        >
          {!selectedItem ? '請選擇飲品'
            : needsFlavor && !selectedFlavor ? '請選擇口味'
            : `確認選擇 ${selectedItem.name}${selectedFlavor ? `(${selectedFlavor})` : ''}`}
        </button>
      </div>
    </div>
  );
}
